import { reports } from "./reports";
import { tableColumnTypes } from "../../tableColumnTypes";
import { FormattedMessage } from "react-intl";
import Tooltip from "../../../components/Common/ToolTip/Tooltip";

export const accessReport = {
  label: <FormattedMessage id="ACCESS_REPORT" />,
  path: (tenantName) => `/${tenantName}/reports/quizReport`,

  navLinks: (navigate, tenantName) => [
    {
      key: 1,
      label: "Reports",
      path: `${reports.path(tenantName)}`,
      onClick: () => navigate(`${reports.path(tenantName)}`),
    },
    {
      key: 2,
      label: <FormattedMessage id="ACCESS_REPORT" />,
      path: `${reports.path(tenantName)}`,
      onClick: () => navigate(`${reports.path(tenantName)}`),
    },
  ],
  columns: (navigate, handleUserPopUp) => [
    {
      ID: 1,
      name: <FormattedMessage id="USERGROUP_USERNAME" />,
      fieldName: "UserName",
      value: (row) => (
        <span
          style={{
            textDecoration: "underline",
            color: "#0051BC",
            cursor: "pointer",
          }}
          onClick={() => handleUserPopUp(row.Id)}
        >
          {row.UserName}
        </span>
      ),
      // sort: true,
      type: tableColumnTypes.STRING,
    },
    {
      ID: 2,
      name: <FormattedMessage id="USERMANAGE_SEARCHEMAIL" />,
      fieldName: "EmailId",
      value: (row) => row.EmailId,
      // sort: true,
      type: tableColumnTypes.NUMBER,
    },
    {
      ID: 3,
      name: <FormattedMessage id="Report_User_Groups" />,
      fieldName: "UserGroups",
      value: (row) => row.UserGroups.slice(1),
      // sort: true,
      type: tableColumnTypes.NUMBER,
    },
    {
      ID: 4,
      name: <FormattedMessage id="NUMBER_OF_LOGINS" />,
      fieldName: "NoOfAttempts",
      value: (row) => row.NoOfAttempts,
      // sort: true,
    },
  ],
};

export const accessReportAAD = {
  label: <FormattedMessage id="ACCESS_REPORT" />,
  path: (tenantName) => `/${tenantName}/reports/quizReport`,

  navLinks: (navigate, tenantName) => [
    {
      key: 1,
      label: "Reports",
      path: `${reports.path(tenantName)}`,
      onClick: () => navigate(`${reports.path(tenantName)}`),
    },
    {
      key: 2,
      label: <FormattedMessage id="ACCESS_REPORT" />,
      path: `${reports.path(tenantName)}`,
      onClick: () => navigate(`${reports.path(tenantName)}`),
    },
  ],
  aadColumns: (navigate, handleAADUserPopUp) => [
    {
      ID: 1,
      name: <FormattedMessage id="USERGROUP_USERNAME" />,
      fieldName: "UserName",
      value: (row) => (
        <span
          style={{
            textDecoration: "underline",
            color: "#0051BC",
            cursor: "pointer",
          }}
          onClick={() => handleAADUserPopUp(row)}
        >
          {row.UserName}
        </span>
      ),
      sort: true,
      type: tableColumnTypes.STRING,
    },
    {
      ID: 2,
      name: <FormattedMessage id="USERMANAGE_SEARCHEMAIL" />,
      fieldName: "EmailId",
      value: (row) => row.EmailId,
      sort: true,
      type: tableColumnTypes.STRING,
    },
    {
      ID: 3,
      name: <FormattedMessage id="Report_User_Groups" />,
      fieldName: "UserGroups",
      value: (row) => {
        const val = row.UserGroups?.split("|")?.slice(1)?.join("| ");
        return (
          <div>
            {val?.length < 25 ? (
              val
            ) : (
              <Tooltip content={val}>{val?.slice(0, 25) + "..."}</Tooltip>
            )}
          </div>
        );
      },
      sort: true,
      type: tableColumnTypes.STRING,
    },
  ],
};
